import { Fragment } from "react";
import { Link } from "react-router-dom";

export interface BreadCrumb {
  label: string;
  to?: string;
}

interface BreadProps {
  crumbs: BreadCrumb[];
}

export function Bread({ crumbs }: BreadProps) {
  return (
    <div className="bread">
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        return (
          <Fragment key={`${i}-${c.label}`}>
            {c.to && !last ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}
            {!last && <span className="bread__sep">/</span>}
          </Fragment>
        );
      })}
    </div>
  );
}
